import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import SweetAlert from "sweetalert-react";
import { useLocation } from "react-router-dom";
import shajs from "sha.js";
import ReactFileReader from "react-file-reader";
import { Tooltip } from 'react-tooltip';

import { Form } from "react-bootstrap";
import { useSentInvitations } from "../../hooks/invitations/Invitations";
import { useSelectLanguage } from "../../hooks/global/Languages";

function CreateBatchSender({ profiles, vendor, importedInvitations, notifyError, removeImportedInvitation, uploadInvitations }) {
  const { t } = useTranslation();
  const location = useLocation();

  const { selectTextByLanguage } = useSelectLanguage();
  const { mutate: sendInvitations, isLoading: isSedning, isError: isError, data: response } = useSentInvitations();

  const [sendingResponse, setSendingResponse] = useState(null);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [timeToSend, setTimeToSend] = useState(0);

  const sha256Hex = (email) => {
    return shajs("sha256").update(email.toLowerCase()).digest("hex");
  };

  const getProfileName = (profileId) => {

    const profile = profiles.find((profile) => profile.id === profileId);
    return profile ? profile.name : "";
  };


  useEffect(() => {
    if (response) setSendingResponse(response);
  }, [response]);

  useEffect(() => {
    if (importedInvitations) setSendingResponse(null);
  }, [importedInvitations]);

  const validationErrorsExist = () => {
    return (
      importedInvitations &&
      importedInvitations.some(
        (invitation) => Object.keys(invitation.validationErrors).length > 0 || sendingResponse?.failurePayloads?.some((fail) => fail.email === sha256Hex(invitation.customerEmail)) || sendingResponse?.result?.some((fail) => {
          //d.email === invitation.customerEmail && fail.status === 'error'; 
          if (fail.status === 'error')
            return true;
          else
            return false;
        })
      )
    );
  };

  const getInvitationErrorMessage = (invitation) => {
    let errorMessage = "";
    if (sendingResponse) {
      let fail = sendingResponse.result.find((fail) => fail.email === sha256Hex(invitation.customerEmail) || fail.email === invitation.customerEmail);
      if (fail) errorMessage = fail.reject_reason//fail.statusCode === 409 ? t("admin.inv.rej") : t("admin.inv.notSent");
    }
    if (Object.keys(invitation.validationErrors).length > 0) {
      errorMessage = Object.values(invitation.validationErrors).join('<br>');
    }
    return errorMessage;
  };

  const reloadPage = () => {
    location.reload();
  };

  const handleSendInvitations = (e) => {
    //setSending(true);
    let invitations = importedInvitations.filter((invitation) => Object.keys(invitation.validationErrors).length === 0)
      .map((invitation) => {
        invitation.sendAfterHours = parseInt(timeToSend);
        invitation.sendProductReviewAfterHours = parseInt(timeToSend);
        return invitation;
      });

    sendInvitations({ data: invitations, message: t('admin.inv.invSent') });
  };


  if (importedInvitations || sendingResponse) {

    importedInvitations = importedInvitations?.map((invitation, key) => {
      invitation.error = getInvitationErrorMessage(invitation) || [];
      return invitation;
    })
  };


  return (
    <div>
      <SweetAlert
        show={showErrorPopup}
        title={t("err.warn")}
        type="warning"
        text={t("admin.inv.notSentP")}
        confirmButtonText={t("admin.common.close")}
        onConfirm={reloadPage}
      />
      <table className="table table-striped">
        <thead>
          <tr>
            <th>{t("admin.inv.status")}</th>
            <th>{t("admin.prize.name")}</th>
            <th>{t("admin.prize.lastname")}</th>
            <th>{t("admin.prize.email")}</th>
            <th>{t("admin.inv.reEl")}</th>
            <th>{t("admin.inv.la")}</th>
            <th>{t("admin.inv.lng")}</th>
            {!sendingResponse && <th>-</th>}
          </tr>
        </thead>
        <tbody>
          {importedInvitations &&
            importedInvitations.map((invitation, key) => (

              <tr key={key} className={invitation.error.length > 0 ? "cellError" : ""} >
                <td className="text-center">


                  {(sendingResponse || validationErrorsExist()) && (
                    <div>

                      {invitation.error.length > 0 ? (
                        <FontAwesomeIcon icon={faTriangleExclamation} style={{ color: "red" }} data-tooltip-id={`errorTooltip`} data-tooltip-html={invitation.error} data-tooltip-place="top" />
                      ) : (
                        sendingResponse && <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#0085ba" }} data-tooltip-content={t("admin.inv.invSent")} />
                      )}
                    </div>
                  )}
                </td>
                <td>{invitation.customerName}</td>
                <td>{invitation.customerSurname}</td>
                <td>{invitation.customerEmail}</td>
                <td>
                  <ul className="elementList">
                    {getProfileName(invitation.profileId).length > 0 && (
                      <li>{getProfileName(invitation.profileId)}</li>
                    )}
                    {invitation.products.map((product, key) => (
                      <li key={key}>{selectTextByLanguage(product.name, invitation.language)}</li>
                    ))}
                  </ul>
                </td>
                <td>{invitation.orderNumber}</td>
                <td>{invitation.language}</td>
                {!sendingResponse && (
                  <td>
                    <button
                      className="btn btn-delete"
                      onClick={() =>
                        removeImportedInvitation(
                          invitation.customerEmail,
                          invitation.profileId
                        )
                      }
                      title={t("admin.common.del")}
                    >
                      {t("admin.common.del")}
                    </button>
                  </td>
                )}
              </tr>
            ))}
        </tbody>
      </table>
      {!sendingResponse &&
        <Form className="batchInvite clearfix" onSubmit={(e) => e.preventDefault()}>

          <div className="delayWrap clearfix">
            <p>{t("admin.inv.time")}
              <div className="delay">
                <div className="form-group send-time">
                  <div className="" style={{ alignContent: "center" }}>
                    {t("admin.inv.getIn")}
                  </div>
                  <div className="">
                    <Form.Control type="number" name="invitationDelay" value={timeToSend} onChange={(e) => setTimeToSend(e.target.value)} />
                  </div>
                  <div className="" style={{ alignContent: "center" }}>{t("admin.inv.h")}.</div>
                </div>
              </div>
            </p>
          </div>

          <div>
          {(validationErrorsExist() && importedInvitations) && ( <em className="warning"><i className="fa fa-warning" aria-hidden="true"></i>{t("admin.inv.error")}.</em>)}

            <div className="buttonWrap d-flex justify-content-center" >

            {(validationErrorsExist() || importedInvitations) && (
              <>
                {!isSedning && (
                  <div style={{ flexGrow: "1" }}>
                    <ReactFileReader handleFiles={uploadInvitations} fileTypes={".csv"}>
                      <button
                        className="btn btn-default btn-send btn btn-primary"
                        title={t("admin.inv.error")}
                      >
                        {t("admin.inv.reUp")}
                      </button>
                    </ReactFileReader>
                  </div>
                )}
              </>
            )}

              {(isSedning) ? <div className="loaderWrap" style={{ position: "relative", margin: "40px" }}><span className="loader loaderSmall" /></div>
                : (importedInvitations?.length > 0 && <button type="submit" className="btn btn-default btn-send" title="Pošlji" onClick={handleSendInvitations}>{t("common.send")}</button>)
              }
            </div>
          </div>
        </Form>
      }
      <Tooltip
        id={`errorTooltip`}
        className="error-tooltip"
        place="top"
        type="error"
        effect="solid"
        style={{ backgroundColor: '#f05228' }}
      />
    </div>
  );
}

export default CreateBatchSender;
